import { Component, OnInit } from '@angular/core';
import { CODIGO_CENTRUS } from '../../../app.constants';
import { StorafeUtil } from '../../shared/util/storasge.util';

@Component({
  selector: 'app-pbb-painel-controle-gerencial',
  templateUrl: './pbb-painel-controle-gerencial.component.html',
  styleUrls: ['./pbb-painel-controle-gerencial.component.css']
})
export class PbbPainelControleGerencialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  param = '/cardMenus/cardMenuPlanos';

  getDadosSesseionStorage(): Promise<string> {
      return new Promise((resolve, reject) => {
          const recuperandoObjeto =
              StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
          resolve(recuperandoObjeto);
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/pbb-painel-controle-gerencial/pbb-painel-controle-gerencial.component.ts